<div class="costs" [ngbTooltip]="costHover" container="body" placement="top" [class.cost-border-left]="borderLeft">
  <div class="cost" *ngIf="cost?.c">
    <ng-container [ngTemplateOutlet]="costTemplate" [ngTemplateOutletContext]="{cost: cost?.c, remaining: remaining?.c, icon: 'candle', iconClass: 'currency'}"></ng-container>
  </div>
  <div class="cost" *ngIf="cost?.sc">
    <ng-container [ngTemplateOutlet]="costTemplate" [ngTemplateOutletContext]="{cost: cost?.sc, remaining: remaining?.sc, icon: 'candle', iconClass: 'seasonal'}"></ng-container>
  </div>
  <div class="cost" *ngIf="cost?.h">
    <ng-container [ngTemplateOutlet]="costTemplate" [ngTemplateOutletContext]="{cost: cost?.h, remaining: remaining?.h, icon: 'heart', iconClass: 'currency'}"></ng-container>
  </div>
  <div class="cost" *ngIf="cost?.sh">
    <ng-container [ngTemplateOutlet]="costTemplate" [ngTemplateOutletContext]="{cost: cost?.sh, remaining: remaining?.sh, icon: 'heart', iconClass: 'seasonal'}"></ng-container>
  </div>
  <div class="cost" *ngIf="cost?.ac">
    <ng-container [ngTemplateOutlet]="costTemplate" [ngTemplateOutletContext]="{cost: cost?.ac, remaining: remaining?.ac, icon: 'ascended-candle', iconClass: 'currency'}"></ng-container>
  </div>
  <div class="cost" *ngIf="cost?.ec">
    <ng-container [ngTemplateOutlet]="costTemplate" [ngTemplateOutletContext]="{cost: cost?.ec, remaining: remaining?.ec, icon: 'ticket', iconClass: 'currency'}"></ng-container>
  </div>
</div>

<ng-template #costTemplate let-cost="cost" let-remaining="remaining" let-icon="icon" let-iconClass="iconClass">
  <mat-icon [class]="iconClass + ' cost-icon icon-middle'" [svgIcon]="icon" [inline]="false"></mat-icon>
  <div>
    <b *ngIf="cost && !remaining" class="c-completed"> {{ cost || 0 }}</b>
    <span *ngIf="remaining"> {{ remaining || 0 }}</span>
    <span *ngIf="cost && remaining" class="c-accent"> ({{ cost || 0 }})</span>
  </div>
</ng-template>

<ng-template #costHover>
  <span>Cost of items not yet unlocked.</span><br/>
  <span *ngIf="remaining" class="c-accent">Total cost of all items.</span><br/>
  <span class="c-completed">All items are unlocked.</span>
</ng-template>
